export const Experiences = [
  {
    title: "Self-Taught Developer",
    desc: "Began learning web development in 2018, focusing on HTML, CSS, and JavaScript.",
    place: "01",
    id: 1,
    delay: 100,
  },
  {
    title: "B.Sc. Computer Science",
    desc: "Completed a Bachelor’s degree in Computer Science at the University of Lagos.",
    place: "02",
    id: 2,
    delay: 200,
  },
  {
    title: "Side-Hustle Internship",
    desc: "Expanded React skills during a 2022 internship at Side-Hustle.",
    place: "03",
    id: 3,
    delay: 300,
  },
  {
    title: "Frontend Developer - HEx",
    desc: "Developed frontend applications for Help Experience LTD products.",
    place: "04",
    id: 4,
    delay: 400,
  },
  {
    title: "Frontend Developer - KlosaNow",
    desc: "Contributed to the development of an E-Learning platform at KlosaNow.",
    place: "05",
    id: 5,
    delay: 500,
  },
  {
    title: "Frontend Intern | HNGX Finalist",
    desc: "Finalist in the tenth edition of the HNG internship program.",
    place: "06",
    id: 6,
    delay: 600,
  },
  {
    title: "Frontend Developer - Rentspace Tech",
    desc: "Worked on web applications as a frontend developer at Rentspace Tech.",
    place: "07",
    id: 7,
    delay: 700,
  },
  {
    title: "Frontend Engineer - Techistry Integrated",
    desc: "Currently working as a frontend engineer at Techistry Integrated, focusing on building scalable web applications.",
    place: "08",
    id: 8,
    delay: 800,
  }
];

export const ExperienceCard = ({ title, desc, place, id, delay }) => {
  return (
    <div className="xp-card-container">
      <span>{place}</span>
      <div
        data-aos={id % 2 === 0 ? "fade-left" : "fade-right"}
        data-aos-delay={delay}
        className={id % 2 === 0 ? "xp-card right" : "xp-card left"}
      >
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  );
};
